import apiClient from '@/services/axios';

export async function update(id, data) {
  const response = await apiClient.put(`/recurringNotifications/${id}`, data);
  if (response) {
    return response.data;
  }
  throw new Error('Unable to update recurring notification.');
}
